import { render, staticRenderFns } from "./buyerCenter.vue?vue&type=template&id=49b473fd&scoped=true&"
import script from "./buyerCenter.vue?vue&type=script&lang=js&"
export * from "./buyerCenter.vue?vue&type=script&lang=js&"
import style0 from "./buyerCenter.vue?vue&type=style&index=0&id=49b473fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b473fd",
  null
  
)

export default component.exports